export default "__VITE_ASSET__COxZ_0QN__"